module.exports = __webpack_public_path__ + "img/046-devil-2.828eb2a1.png";